module.exports = __webpack_public_path__ + "img/comment.68059f16.svg";